import React from 'react';
import { CircularProgress } from '@mui/material';
import { useLoadingSpinnerContext } from '../../../contexts/loading-spinner-context';

export default () => {
  const { isShowing } = useLoadingSpinnerContext();

  if (!isShowing) return null;

  return (
    <div className="loading-spinner" data-testid="loading-spinner">
      <div className="loading-spinner-wrapper" data-testid="loading-spinner-wrapper">
        <CircularProgress />
      </div>
    </div>
  );
};
